import {
  BookOutlined,
  PartitionOutlined,
  BranchesOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import departamentos from '../../menus/icons/departamentos'
import ciclo from '../../menus/icons/ciclo'

let AdminModuloEstructura = [
  {
    key: 'Estructura',
    path: `${APP_PREFIX_PATH}/admin/estructura`,
    title: 'sidenav.admin.estructura.estructura',
    icon: PartitionOutlined,
    breadcrumb: true,
    permission:['Read:dptos','Read:planesEstudio','Read:ciclos','Read:horarios'],
    submenu: [
      {
        key: 'Vista General',
        path: `${APP_PREFIX_PATH}/admin/estructura/general`,
        title: 'sidenav.admin.estructura.general',
        icon: BranchesOutlined,
        permission:['Create:dptos'],
        breadcrumb: true,
      },
      {
        key: 'Departamentos Academicos',
        path: `${APP_PREFIX_PATH}/admin/dptosacademicos`,
        title: 'sidenav.admin.estructura.departamentos',
        icon: departamentos,
        permission:['Read:dptos'],
        breadcrumb: true,
      },
      {
        key: 'Planes Estudio',
        path: `${APP_PREFIX_PATH}/admin/planes-estudio`,
        title: 'sidenav.admin.estructura.planesEstudio',
        icon: BookOutlined,
        breadcrumb: true,
        permission:['Read:planesEstudio'],
        submenu: []
      },
      {
        key: 'Ciclos Escolares',
        path: `${APP_PREFIX_PATH}/admin/ciclos`,
        title: 'sidenav.admin.estructura.ciclos',
        icon: ciclo,
        breadcrumb: true,
        permission:['Read:ciclos'],
        submenu: []
      },
      {
        key: 'Horarios Clase',
        path: `${APP_PREFIX_PATH}/admin/horarios`,
        title: 'sidenav.admin.estructura.horarios',
        icon: ScheduleOutlined,
        breadcrumb: true,
        permission:['Read:horarios'],
        submenu: []
      },
    ]
  }
]

export default AdminModuloEstructura;
